export default "/_next/static/chunks/fonts/Raleway-Bold-latin-ec346e63f9c27f46e57dc438b3a525d7.woff2";